(function () {
  const STORAGE_KEY = 'sg:collection-view';
  const ALLOWED_VIEWS = ['1', '2'];
  const root = document.documentElement;

  function storedView() {
    try {
      const value = window.localStorage.getItem(STORAGE_KEY);
      return ALLOWED_VIEWS.indexOf(value) !== -1 ? value : null;
    } catch (error) {
      return null;
    }
  }

  function syncButtons() {
    const view = root.getAttribute('data-collection-view');
    document.querySelectorAll('.collection-view-toggle__button').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.collectionViewValue === view ? 'true' : 'false');
    });
  }

  const CARD_SELECTOR = '#product-grid > .grid__item:not(.grid__item--callout)';
  const cardObserver = 'ResizeObserver' in window ? new ResizeObserver(syncCardHeight) : null;
  let observedCard = null;

  function syncCardHeight() {
    const card = document.querySelector(CARD_SELECTOR);
    if (!card) {
      root.style.removeProperty('--collection-card-height');
      return;
    }

    if (cardObserver && observedCard !== card) {
      cardObserver.disconnect();
      cardObserver.observe(card);
      observedCard = card;
    }

    root.style.setProperty('--collection-card-height', card.getBoundingClientRect().height + 'px');
  }

  function applyView(view, persist) {
    root.setAttribute('data-collection-view', view);

    if (persist) {
      try {
        window.localStorage.setItem(STORAGE_KEY, view);
      } catch (error) {
      }
    }

    syncButtons();
    syncCardHeight();
  }

  applyView(storedView() || root.getAttribute('data-collection-view') || '2', false);

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.collection-view-toggle__button');
    if (!button) return;

    event.preventDefault();
    applyView(button.dataset.collectionViewValue, true);
  });

  window.addEventListener('resize', syncCardHeight);
  window.addEventListener('load', syncCardHeight);

  document.addEventListener('DOMContentLoaded', function () {
    syncButtons();
    syncCardHeight();

    var gridContainer = document.getElementById('ProductGridContainer');
    if (gridContainer && 'MutationObserver' in window) {
      new MutationObserver(syncCardHeight).observe(gridContainer, { childList: true, subtree: true });
    }
  });
})();
